(function() {
  const COOKIE_FIRST_VISIT = 'sivo_first_visit';
  const COOKIE_LAST_VISIT = 'sivo_last_visit';
  const COOKIE_SESSION_ID = 'sivo_session_id';
  const GOOGLE_SHEETS_ENDPOINT = 'https://services.sivocloud.com/google-sheets/append';
  const SPREADSHEET_ID = '1PKi4JO7qLiT0DNzFmPQIbBS2Ye_LPvYm-TY2fGkrQk0';
  const EXPIRY_DAYS = 365;
  const TIMEZONE = 'America/Bogota'; // Configurado a UTC-5
  
  // Función para obtener una cookie
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
    return null;
  }
  
  // Función para crear una cookie
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
  }

  // === NUEVA FUNCIÓN: Obtener fecha en UTC-5 formateada ===
  function getSivoDate() {
    // Usamos formato sueco (sv-SE) porque da el formato ISO (YYYY-MM-DD) automáticamente
    // y forzamos la zona horaria a America/Bogota
    try {
      const dateString = new Date().toLocaleString('sv-SE', { 
        timeZone: TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
      // Reemplazamos el espacio por T para mantener consistencia visual: 2025-01-01T15:00:00
      return dateString.replace(' ', 'T');
    } catch (e) {
      // Fallback por si el navegador es muy viejo
      return new Date().toISOString(); 
    }
  }
  
  // Generar o recuperar session ID
  function getSessionId() {
    let sessionId = getCookie(COOKIE_SESSION_ID);
    if (!sessionId) {
      sessionId = 'sivo_' + Date.now() + '_' + Math.random().toString(36).substring(2, 15);
      setCookie(COOKIE_SESSION_ID, sessionId, EXPIRY_DAYS);
    }
    return sessionId;
  }
  
  // Función para obtener parámetros UTM de la URL
  function getUTMParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = {};
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
    
    utmKeys.forEach(key => {
      const value = urlParams.get(key);
      if (value) {
        utmParams[key] = value;
      }
    });
    
    return Object.keys(utmParams).length > 0 ? utmParams : null;
  }
  
  // Función para verificar si viene de fuera del sitio
  function isExternalVisit() {
    if (!document.referrer || document.referrer === '') { return true; }
    try {
      const referrerUrl = new URL(document.referrer);
      const currentUrl = new URL(window.location.href);
      return referrerUrl.hostname !== currentUrl.hostname;
    } catch (e) { return true; }
  }
  
  // Función para obtener referrer
  function getReferrer() {
    if (document.referrer && document.referrer !== '') {
      try {
        const referrerUrl = new URL(document.referrer);
        if (referrerUrl.hostname !== window.location.hostname) {
          return document.referrer;
        }
      } catch (e) { return document.referrer; }
    }
    return 'direct';
  }
  
  // Función para enviar a Google Sheets
  async function sendToGoogleSheets(data) {
    try {
      const rowData = [
        data.visit_date,
        data.type,
        data.visit_url,
        data.source,
        data.referrer,
        data.utm_source || '',
        data.utm_medium || '',
        data.utm_campaign || '',
        data.utm_term || '',
        data.utm_content || '',
        data.session_id,
        data.user_agent
      ];
      
      const response = await fetch(GOOGLE_SHEETS_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          spreadsheetId: SPREADSHEET_ID,
          range: 'shopify!A:L',
          values: [rowData]
        })
      });
      
      if (response.ok) { console.log('✅ Datos enviados a Google Sheets:', data); }
    } catch (error) { console.error('❌ Error enviando a Google Sheets:', error); }
  }
  
  // Función para agregar attributes al carrito
  async function addAttributesToCart() {
    const firstVisit = window.sivoGetFirstVisit();
    const lastVisit = window.sivoGetLastVisit();
    
    if (!firstVisit) return;
    
    const attributes = {
      'sivo_first_source': firstVisit.source || '',
      'sivo_first_utm_source': firstVisit.utm_source || '',
      'sivo_first_utm_medium': firstVisit.utm_medium || '',
      'sivo_first_utm_campaign': firstVisit.utm_campaign || '',
      'sivo_first_utm_term': firstVisit.utm_term || '',       
      'sivo_first_utm_content': firstVisit.utm_content || '', 
      'sivo_first_visit_date': firstVisit.visit_date || '',
      
      'sivo_last_source': lastVisit?.source || '',
      'sivo_last_utm_source': lastVisit?.utm_source || '',
      'sivo_last_utm_medium': lastVisit?.utm_medium || '',    
      'sivo_last_utm_campaign': lastVisit?.utm_campaign || '',
      'sivo_last_utm_term': lastVisit?.utm_term || '',       
      
      'sivo_shopify_session_id': firstVisit.session_id || ''
    };
    
    // Limpieza de atributos vacíos
    Object.keys(attributes).forEach(key => {
      if (!attributes[key]) delete attributes[key];
    });

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes })
      });
      if (response.ok) console.log('✅ Attributes agregados al carrito:', attributes);
    } catch (error) { console.error('❌ Error attributes:', error); }
  }
  
  // Función principal
  function sivoTracker() {
    const isExternal = isExternalVisit();
    
    if (!isExternal) {
      const firstVisit = window.sivoGetFirstVisit();
      if (firstVisit) { setTimeout(() => addAttributesToCart(), 500); }
      return;
    }
    
    console.log('🌐 Visita externa detectada');
    
    const currentUTMs = getUTMParams();
    const referrer = getReferrer();
    const currentUrl = window.location.href;
    const currentDate = getSivoDate(); // ✅ AHORA USA LA HORA LOCAL UTC-5
    const sessionId = getSessionId();
    const userAgent = navigator.userAgent;
    
    const visitData = {
      visit_date: currentDate,
      visit_url: currentUrl,
      source: currentUTMs?.utm_source || referrer,
      referrer: referrer,
      utm_source: currentUTMs?.utm_source,
      utm_medium: currentUTMs?.utm_medium,
      utm_campaign: currentUTMs?.utm_campaign,
      utm_term: currentUTMs?.utm_term,
      utm_content: currentUTMs?.utm_content,
      session_id: sessionId,
      user_agent: userAgent
    };
    
    const existingFirstVisit = getCookie(COOKIE_FIRST_VISIT);
    
    if (!existingFirstVisit) {
      const firstVisitData = { ...visitData, type: 'first_visit' };
      setCookie(COOKIE_FIRST_VISIT, encodeURIComponent(JSON.stringify(firstVisitData)), EXPIRY_DAYS);
      sendToGoogleSheets(firstVisitData);
    }
    
    const lastVisitData = { ...visitData, type: 'last_visit' };
    setCookie(COOKIE_LAST_VISIT, encodeURIComponent(JSON.stringify(lastVisitData)), EXPIRY_DAYS);
    sendToGoogleSheets(lastVisitData);
    
    setTimeout(() => addAttributesToCart(), 500);
  }
  
  sivoTracker();
  
  // === FUNCIONES PÚBLICAS ===
  window.sivoGetFirstVisit = function() {
    const cookie = getCookie(COOKIE_FIRST_VISIT);
    return cookie ? JSON.parse(decodeURIComponent(cookie)) : null;
  };
  window.sivoGetLastVisit = function() {
    const cookie = getCookie(COOKIE_LAST_VISIT);
    return cookie ? JSON.parse(decodeURIComponent(cookie)) : null;
  };
  window.sivoClearCookies = function() {
    const epoch = 'Thu, 01 Jan 1970 00:00:00 UTC';
    document.cookie = `${COOKIE_FIRST_VISIT}=; expires=${epoch}; path=/;`;
    document.cookie = `${COOKIE_LAST_VISIT}=; expires=${epoch}; path=/;`;
    document.cookie = `${COOKIE_SESSION_ID}=; expires=${epoch}; path=/;`;
    console.log('🗑️ Cookies eliminadas');
  };
})();